import { createAction } from "@reduxjs/toolkit";
import {
  SET_PARTNER_STREAM,
  SET_SIGNALING_SESSION_HOLD,
  SET_SIGNALING_STATUS,
  SET_USER_STREAM,
  SetPartnerStreamActionType,
  SetSignalingSessionHoldActionType,
  SetSignalingStatusActionType,
  SetUserStreamActionType,
  STOP_PARTNER_STREAM,
  STOP_USER_STREAM,
} from "./types";

export const setSignalingStatus = createAction<SetSignalingStatusActionType["payload"]>(SET_SIGNALING_STATUS);
export const setUserStream = createAction<SetUserStreamActionType["payload"]>(SET_USER_STREAM);
export const setPartnerStream = createAction<SetPartnerStreamActionType["payload"]>(SET_PARTNER_STREAM);
export const stopUserStream = createAction(STOP_USER_STREAM);
export const stopPartnerStream = createAction(STOP_PARTNER_STREAM);
export const setSignalingSessionHold = createAction<SetSignalingSessionHoldActionType["payload"]>(SET_SIGNALING_SESSION_HOLD);
